module.exports = __webpack_public_path__ + "img/icon-wrong.e342dbb2.svg";